export function parseAndResolve(json) {
  const refMap = {};

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-argument
  return JSON.parse(json, function (key, value) {
    if (key === '$id') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
      refMap[value] = this;
      // return undefined so that the property is deleted
      return void 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (value && value.$ref) {
      return refMap[value.$ref];
    }

    return value;
  });
}
